
import Vue from "vue";
import { mapActions } from "vuex";
import dayjs from "dayjs";
import dialogMixin from "@/common/mixins/dialogModal";
import LoadingRedirectPage from "@/components/LoadingRedirectPage.vue";
import HexCompany from "@/components/HexCompany.vue";

export default Vue.extend({
  name: "CompanyMonitor",
  mixins: [dialogMixin],
  components: { HexCompany, LoadingRedirectPage },
  data() {
    return {
      allCompanies: [],
      companies: [],
      total: 0,
      isLoading: true,
      refreshAt: null as any,
      isAutoReloadData: null as any,
      filters: {
        showInternalCompanies: true,
        showAllStatuses: false,
      },
    };
  },
  async created() {
    await this.fetchCompanies();
  },
  mounted() {
    this.isAutoReloadData = setInterval(() => {
      this.fetchCompanies();
    }, 600000); // 600000 ms = 10 min
  },
  beforeDestroy() {
    if (this.isAutoReloadData) {
      clearInterval(this.isAutoReloadData);
    }
  },
  methods: {
    ...mapActions(["getCompany", "getStructure"]),
    async handleRefresh() {
      this.fetchCompanies();
    },
    async fetchCompanies() {
      try {
        this.isLoading = true;
        const response = await (this as any).$dep.companyUseCase.getCompaniesWithStatus();
        this.allCompanies = response;
        this.applyFilters();
        this.refreshAt = new Date();
      } catch (error) {
        this.companies = [];
        this.total = 0;
      } finally {
        this.isLoading = false;
      }
    },
    toggleFilter(key: "showInternalCompanies" | "showAllStatuses") {
      this.filters[key] = !this.filters[key];
      this.applyFilters();
    },
    applyFilters() {
      this.companies = this.allCompanies.filter((company: any) => {
        const showInternalCompanies = this.filters.showInternalCompanies ? company.is_internal : true;

        const showAllStatuses = this.filters.showAllStatuses
          ? true
          : (company.dashboard_data?.allAlarmModel || 0) +
              (company.dashboard_data?.allWarningModel || 0) +
              (company.dashboard_data?.allNormalModel || 0) >
            0;

        return showInternalCompanies && showAllStatuses;
      });

      this.total = this.companies.length;
    },
    async onSelected(company: any) {
      const { id } = company;
      const route = this.$router.resolve({
        name: "CompanyPage",
        params: { id },
      });
      window.open(route.href, "_blank");
    },
    formatDate(date: any, format = "DD MMM YYYY, HH:mm") {
      return dayjs(date).format(format);
    },
  },
});
